module.exports = __webpack_public_path__ + "img/roleIdGuide.4fe89494.png";